module.exports = __webpack_public_path__ + "static/media/Dell UltraSharp 5K Monitor 27\".45900cda.png";